import React from "react";

const NoteBox = ({ children }) => {
    return (
        <div className="clone-note-box">
            <strong>Note:</strong> {children}
            <style>{`
        .clone-note-box {
          background-color: #f7f7f9;
          border: 1px solid #dcdcdc;
          border-radius: 6px;
          padding: 12px 16px;
          font-size: 14px;
          line-height: 1.6;
        text-align: center;

          
        }

        .clone-note-box strong {
          font-weight: 600;
          margin-right: 4px;
        }
      `}</style>
        </div>
    );
};

export default NoteBox;
